export const getAllMunicipality = "GET_ALL_MUNICIPALITY";
export const getAllProvince = "GET_ALL_PROVINCE";
export const getAllCompany = "GET_ALL_COMPANY";
export const getAllDriver = "GET_ALL_DRIVER";
export const getAllCity = "GET_ALL_CITY";
export const userInfo = "USER_INFO";
export const getAllOrder = "GET_ALL_ORDER";
export const getAllClient = "GET_ALL_CLIENT";
export const getAllCategory = "GET_ALL_CATEGORY";
export const getAllWorkTime = "GET_ALL_WORK_TIME";
export const getAllArea = "GET_ALL_AREA";
export const getAllTicket = "GET_ALL_TICKET";
